<div class="page-container show-desktop-small-and-above">
    <section class="above-fold-container">
        <app-page-title [biggerWidth]="true" pageTitle="android-partner-stores.title" subtitle="android-partner-stores.sub-title"></app-page-title>
    </section>

    <section class="section-no-padding-bottom">
        <app-selling-point-section
            [pageTitle]="'android-partner-stores.selling-point-1.title' | translate"
            [subtitle]="'android-partner-stores.selling-point-1.sub-title' | translate"
            imgSrc="/assets/img/android-partner-stores/selling-point-1.webp"
        ></app-selling-point-section>
    </section>
    <section class="section">
        <app-selling-point-section
            [pageTitle]="'android-partner-stores.selling-point-2.title' | translate"
            [subtitle]="'android-partner-stores.selling-point-2.sub-title' | translate"
            imgSrc="/assets/img/android-partner-stores/selling-point-2.webp"
            reverse="true"
        ></app-selling-point-section>
    </section>
    <section class="section">
        <app-partners-section></app-partners-section>
    </section>
    <section class="section-no-padding-bottom">
        <app-unleash-section></app-unleash-section>
    </section>
</div>

<div class="page-container-mobile show-tablet-and-below">
    <section class="above-fold-container-mobile">
        <app-page-title [mobile]="true" pageTitle="android-partner-stores.title" subtitle="android-partner-stores.sub-title"></app-page-title>
    </section>

    <section class="section">
        <app-selling-point-section
            [pageTitle]="'android-partner-stores.selling-point-1.title' | translate"
            [subtitle]="'android-partner-stores.selling-point-1.sub-title' | translate"
            imgSrc="/assets/img/android-partner-stores/selling-point-1.webp"
            [mobile]="true"
        ></app-selling-point-section>
    </section>
    <section class="section">
        <app-selling-point-section
            [pageTitle]="'android-partner-stores.selling-point-2.title' | translate"
            [subtitle]="'android-partner-stores.selling-point-2.sub-title' | translate"
            imgSrc="/assets/img/android-partner-stores/selling-point-2.webp"
            [mobile]="true"
        ></app-selling-point-section>
    </section>
    <section class="section-full-width">
        <app-partners-section [mobile]="true"></app-partners-section>
    </section>
    <section class="section-no-padding-bottom no-lateral-padding">
        <app-unleash-section [mobile]="true"></app-unleash-section>
    </section>
</div>
